// constants
export const SIDE_SPACING = 16;
export const TOP_SPACING = 34;
export const PAGE_MARGIN = 30;
export const MIN_PDF_WIDTH = 1320;
export const MIN_PDF_HEIGHT = 1020;
